import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/apiService";

export const GetReportByAppGuid = createAsyncThunk(
  "dropdowns/GetReport_",
  async (Parameter, { rejectWithValue }) => {
    console.log("sdsdssaccascdsdsdsd");

    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_Reports/GetRportsByAppGUID",
        Parameter
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const ChangeRportStatusByAppGUID = createAsyncThunk(
  "dropdowns/ChangeRportStatusByAppGUID",
  async (Parameter, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_Reports/ChangeRportStatusByAppGUID",
        {
          PR_ReportStatusGuid: Parameter.PR_ReportStatusGuid,
          AP_ApplicationInformationGUID:
            Parameter.AP_ApplicationInformationGUID,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
const GetReportByAppGuidReducers = createSlice({
  name: "TypeOfJobOpportunityDropDown",
  initialState: {
    ReportByApp: [],
    loadingReportByApp: false,
    errorReportByApp: null,
    //--------------------------------------
    ChangeRportStatus: [],
    loadingChangeRportStatus: false,
    errorChangeRportStatus: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetReportByAppGuid.pending, (state, action) => {
        state.loadingReportByApp = true;
        state.ReportByApp = action.payload;
        state.errorReportByApp = null;
      })
      .addCase(GetReportByAppGuid.fulfilled, (state, action) => {
        state.loadingReportByApp = false;
        state.ReportByApp = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetReportByAppGuid.rejected, (state, action) => {
        state.loadingReportByApp = false;
        state.errorReportByApp = action.payload;
      });
    //------------------------------------------------------------
    builder
      .addCase(ChangeRportStatusByAppGUID.pending, (state, action) => {
        state.loadingChangeRportStatus = true;
        state.ChangeRportStatus = action.payload;
        state.errorChangeRportStatus = null;
      })
      .addCase(ChangeRportStatusByAppGUID.fulfilled, (state, action) => {
        state.loadingChangeRportStatus = false;
        state.ChangeRportStatus = action.payload; // Assuming payload has the desired data
      })
      .addCase(ChangeRportStatusByAppGUID.rejected, (state, action) => {
        state.loadingChangeRportStatus = false;
        state.errorChangeRportStatus = action.payload;
      });
  },
});

export default GetReportByAppGuidReducers.reducer;
